<template>
  <div class="main">
    <div
      class="dropzone-container" >
<!--      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"-->

      <p>️⚠️ Warning - Uploading Excel files is currently disabled. This feature is not available at the moment.</p>
      <input
        type="file"
        multiple
        name="file"
        id="fileInput"
        class="hidden-input"
        @change="onChange"
        ref="file"
        accept=".xls,.xlsx,.xlsm"
      />

<!--      <label for="fileInput" class="file-label" @click.prevent="disableFileClick">
        <div v-if="isDragging">Release to drop files here.</div>
        <div v-else>Drop files here or <u>click here</u> to upload.</div>
      </label>-->

      <div v-if="error" class="error-message">{{ error }}</div>

      <div class="preview-container mt-4" v-if="files.length">
        <div
          v-for="(file, index) in files"
          :key="file.name"
          class="preview-card"
        >
          <div class="file-info">
            <p class="file-name" :title="file.name">{{ file.name }}</p>
            <button
              class="preview-button"
              type="button"
              @click="previewFile(file)"
              title="Preview file"
            >
              Preview
            </button>
          </div>
          <button
            class="remove-button"
            type="button"
            @click="remove(files.indexOf(file))"
            title="Remove file"
          >
            <b>×</b>
          </button>
        </div>
        <div v-if="files.length > this.maxfile" class="extra-files">
          +{{ files.length - this.maxfile }}
        </div>
      </div>
    </div>

    <v-btn
      class="rounded white--text"
      color="green"
      size="small"
      variant="flat"
      :disabled="!files.length"
      @click="upload"
    >
      Save
    </v-btn>

    <v-btn
      class="rounded white--text"
      color="red"
      size="small"
      variant="flat"
      :disabled="!files.length"
      @click="empty"
    >
      Remove all files
    </v-btn>

    <v-btn
      class="pl-0 ml-0"
      flat
      icon
      color="primary"
      @click="showDialog = true"
    >
      <v-icon>mdi-help-circle-outline</v-icon>
    </v-btn>

    <!-- Modal for description -->
    <v-dialog v-model="showDialog" max-width="75%">
      <v-card>
        <v-card-title class="headline">Upload Startup excel files</v-card-title>
        <v-card-text>
          <ol>
            <li>
              Upload the files through drag and drop or by clicking the underline
              click here and select excel files.
            </li>
            <li>
              Click the preview button to show the content of the excel file,
              close the dialog through the upper left red button.
            </li>
            <li>
              Click the upper right red button of the file card to remove the
              single file.
            </li>
            <li>
              Click the "REMOVE ALL FILES" button to remove all files load in
              the drag and drop container.
            </li>
            <li>
              Click the "SAVE" to start uploading all files present in the drag
              and drop zone
            </li>
          </ol>
          <br />
          This is a video showing how to do this:<br />
          <video width="900" height="556" controls>
            <source
              src="../../../assets/img/files/gif/excel_upload.webm"
              type="video/webm"
            />
            Your browser does not support the video tag.
          </video>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="showDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal for previewing the file content -->
    <div v-if="showPreview" class="preview-modal">
      <div class="preview-modal-content">
        <button class="close-button" @click="closePreview">×</button>
        <div v-html="fileContent"></div>
      </div>
    </div>

    <!-- Duplicated files warning alert -->
    <div v-if="showDuplicatedAlert" class="warning-container">
      <p class="warning-title">⚠️ Warning - The following files have startups already present in Discovery. You should consult an administrator to see if you need to change existing startups, otherwise you may want to change the name of the startups in the file.</p>
      <ul class="file-list">
        <li v-for="(duplicates, fileName) in duplicated" :key="fileName" class="file-item">
          <strong>{{ fileName }}</strong>:
          <ul class="startup-list">
            <li v-for="startup in duplicates" :key="startup" class="startup-item">{{ startup }}</li>
          </ul>
        </li>
      </ul>
      <button class="remove-warning-button" @click="removeWarning">Dismiss</button>
    </div>
    <!-- Upload Error message -->
    <div v-if="Object.keys(uploadError).length" class="error-container">
      <p class="error-title">❌ Error - The following files have unexpected column names. We recommend that you review the file to correct any errors or contact an administrator.</p>
      <ul class="file-list">
        <li v-for="(errorDetails, fileName) in uploadError" :key="fileName" class="file-item">
          <strong>{{ fileName }}</strong>:
          <ul v-if="errorDetails.wrongColumns && Object.keys(errorDetails.wrongColumns).length" class="column-list">
            <li v-for="(incorrect, correct) in errorDetails.wrongColumns" :key="correct" class="column-item">
              <strong>{{ incorrect }}</strong> is not valid. Did you mean <strong>{{ correct }}</strong>?
            </li>
          </ul>
        </li>
      </ul>
      <button class="remove-warning-button" @click="clearUploadError">Dismiss</button>
    </div>

  </div>
</template>

<script>
import UrlsService from "@/helpers/UrlsService.js";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import TimeService from "@/helpers/TimeService";
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      isDragging: false,
      files: [],
      error: null,
      maxfile: 6,
      showPreview: false,
      fileContent: "",
      showScoreTables: false,
      showDialog: false,
      duplicated: {},
      showDuplicatedAlert: false,
      uploadError: {}
    };
  },
  methods: {
    // onChange() {
    //   this.error = null;
    //   const selectedFiles = [...this.files, ...this.$refs.file.files];
    //   const validFiles = [];
    //   for (let file of selectedFiles) {
    //     if (
    //       file.name.endsWith(".xls") ||
    //       file.name.endsWith(".xlsx") ||
    //       file.name.endsWith(".xlsm")
    //     ) {
    //       if (!this.files.find((f) => f.name === file.name)) {
    //         validFiles.push(file);
    //       } else {
    //         this.error = "File " + file.name + " is already uploaded.";
    //       }
    //     } else {
    //       this.error = "Only .xls, .xlsx, and .xlsm files are allowed.";
    //     }
    //   }
    //   this.files = [...this.files, ...validFiles];
    //   this.$refs.file.value = '';
    // },
    onChange() {
      this.error = null;  // Clear any existing error messages
      const selectedFiles = [...this.$refs.file.files];  // Get the newly selected files

      // Iterate over each selected file
      selectedFiles.forEach(file => {
        if (file.name.endsWith(".xls") || file.name.endsWith(".xlsx") || file.name.endsWith(".xlsm")) {
          // Check if the file name already exists in the files array
          const existingFile = this.files.find(f => f.name === file.name);
          if (!existingFile) {
            // If no existing file with the same name, add it to validFiles
            this.files.push(file);
          } else {
            // If a file with the same name already exists, set an error message
            this.error = `File ${file.name} is already uploaded.`;
          }
        } else {
          // If the file is not of the allowed types, set an error message
          this.error = "Only .xls, .xlsx, and .xlsm files are allowed.";
        }
      });

      // Clear the file input to allow the same file to be uploaded again if necessary
      this.$refs.file.value = '';
    },

    generateThumbnail(file) {
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },

    remove(i) {
      this.files.splice(i, 1);
    },

    removeWarning() {
      this.showDuplicatedAlert = false;
      this.duplicated = {};
    },

    clearUploadError() {
      this.uploadError = {}; // Clear the uploadError
    },

    disableFileClick(event) {
      event.preventDefault();
      this.error = "Uploading is currently disabled.";
    },

    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },

    dragleave() {
      this.isDragging = false;
    },

    drop(e) {
      e.preventDefault();
      const droppedFiles = [...this.files, ...e.dataTransfer.files];
      const validFiles = [];
      for (let file of droppedFiles) {
        if (
          file.name.endsWith(".xls") ||
          file.name.endsWith(".xlsx") ||
          file.name.endsWith(".xlsm")
        ) {
          if (!this.files.find((f) => f.name === file.name)) {
            validFiles.push(file);
          } else {
            this.error = "File " + file.name + " is already uploaded.";
          }
        } else {
          this.error = "Only .xls, .xlsx, and .xlsm files are allowed.";
        }
      }
      this.files = [...this.files, ...validFiles];
      this.isDragging = false;
      this.$refs.file.value = '';
    },

    upload() {
      let messages = {
        title: "Uploading excels",
        loading: "Uploading...",
        error: "Error during upload of files",
        success: ""
      };
      
      let options = {
        loadingType: "fullscreen+notification",
        timeout: TimeService.secondsToMillis(0),
      };

      const uploadPromises = this.files.map((file) => {
        let requestUrl = {
          url: UrlsService.uploadExcel,
          timeout: TimeService.secondsToMillis(0),
        };
        let requestData = {
          interactionData: {},
        };

        let requestObject = {
          type: "upload",
          urlsInfo: requestUrl,
          data: {
            data: requestData,
            file: file,
          },
        };

        return APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then((Response) => {
            // Handle successful response
            console.log("STATUS:", Response.response.status);

            if (Response.response.status == 400){
              console.log("Entering:", Response);
              // Assuming wrongColumns is structured as an array of objects
              this.$set(this.uploadError, file.name, {
                wrongColumns: Response.response.data.response.wrongColumns || {} // array of wrong columns
              });
            } 

            if (Array.isArray(Response.response.duplicatedStartups) && Response.response.duplicatedStartups.length > 0) {
              this.$set(this.duplicated, file.name, Response.response.duplicatedStartups);
            }
          })
          .catch((error) => {
            console.error('Upload error:', error); // Log the error for debugging
            this.error = `Failed to upload ${file.name}. Please check the file and try again.`;
          });
      });

      Promise.all(uploadPromises).then(() => {
        // Check if there are any duplicated startups
        if (Object.keys(this.duplicated).length > 0) {
          this.showDuplicatedAlert = true;
        }

        this.files = [];
        console.log("Upload error:", this.uploadError); // Check if uploadError is set correctly
      }).catch(() => {
            this.error = "There was an issue with the upload. Please try again.";
      })
    },

    empty() {
      this.files = [];
      this.$refs.file.value = '';
    },

    previewFile(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const html = XLSX.utils.sheet_to_html(worksheet);
        this.fileContent = html;
        this.showPreview = true;
      };
      reader.readAsArrayBuffer(file);
    },

    closePreview() {
      this.showPreview = false;
      this.fileContent = "";
    },
  },
};
</script>

<style scoped>
.main {
  display: flex;
  flex-grow: 1;
  align-items: center;
  height: 100vh;
  justify-content: center;
  text-align: center;
}

.dropzone-container {
  padding: 4rem;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 10px;
  margin-top: 2rem;
  width: 100%;
}

.preview-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #a2a2a2;
  padding: 10px;
  border-radius: 5px;
}

.file-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
  margin-bottom: 10px;
}

.file-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
  text-align: center;
}

.error-message {
  color: red;
  margin-top: 1rem;
}

.extra-files {
  color: #888;
  font-size: 1.2em;
  margin-top: 10px;
  font-weight: bold;
}

.remove-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.remove-button:hover {
  background-color: darkred;
}

.preview-button {
  margin-top: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
}

.preview-button:hover {
  background-color: #0056b3;
}

.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-modal-content {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 5px;
  max-width: 80%;
  max-height: 80%;
  overflow: auto;
}

.close-button {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
}

.close-button:hover {
  background-color: darkred;
}

.warning-container {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 20px auto;
}

.warning-title {
  color: #856404;
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 10px;
}

.file-list {
  list-style-type: none;
  padding: 0;
}

.file-item {
  margin-bottom: 10px;
}

.startup-list {
  list-style-type: disc;
  margin-left: 20px;
}

.startup-item {
  margin-bottom: 5px;
}

.remove-warning-button {
  background-color: #f8d7da;
  color: #721c24;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.remove-warning-button:hover {
  background-color: #f5c6cb;
}

.error-container {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 20px auto;
}

.error-title {
  color: #721c24;
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 10px;
}

.file-list {
  list-style-type: none;
  padding: 0;
}

.file-item {
  margin-bottom: 10px;
}

.column-list {
  list-style-type: disc;
  margin-left: 20px;
}

.column-item {
  margin-bottom: 5px;
}

.remove-warning-button {
  background-color: #fff3cd;
  color: #856404;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.remove-warning-button:hover {
  background-color: #ffeeba;
}


</style>
